module.exports = __webpack_public_path__ + "img/airtel_logo.b4fc46ac.svg";